class FacebookShare {
  constructor() {
    this.initComponents()
    this.bindEvents()
  }

  initComponents() {
    this.shareLinks = document.querySelectorAll("[data-media-share]")
  }

  bindEvents() {
    this.shareLinks.forEach(link => {
      link.addEventListener("click", e => {
        window.open(e.currentTarget.href, "pop", "width=600, height=400")
        e.preventDefault()
      })
    })
  }
}

export default function init() {
  new FacebookShare()
}
